module.exports = __webpack_public_path__ + "img/icon_sec3_02.1331a44c.png";